import { useGoToAnnotation } from "@/hooks/use-go-to-annotation";
import { setCurrentAnnotationId } from "@/store/ai-asset-review/ai-asset-review-slice";
import { changeMode } from "@/store/mode-slice";
import { useAppDispatch } from "@/store/store-hooks";
import { deactivateTool } from "@/store/ui/ui-slice";
import {
  setObjectVisibility,
  ViewObjectTypes,
} from "@/store/view-options/view-options-slice";
import { GUID } from "@faro-lotv/foundation";
import { MarkupIElement } from "@faro-lotv/ielement-types";
import { useCallback } from "react";

/**
 * Hook for navigating to an AI-detected annotation from the review interface
 *
 * @param markup The markup element to navigate to
 * @returns Function to navigate to the annotation
 */
export function useReviewAnnotationInScene(
  markup: MarkupIElement | undefined,
): (annotationId: GUID) => void {
  const dispatch = useAppDispatch();
  const goToAnnotation = useGoToAnnotation();

  return useCallback(
    (annotationId: GUID) => {
      if (!markup) return;

      dispatch(setCurrentAnnotationId(annotationId));
      dispatch(deactivateTool());
      dispatch(changeMode("sheet"));
      dispatch(
        setObjectVisibility({
          type: ViewObjectTypes.annotations,
          visibility: true,
        }),
      );
      goToAnnotation(markup);
    },
    [dispatch, goToAnnotation, markup],
  );
}
